var modules_c052660e = {"container":"_1oeswo9","dropdown":"_9a1vxf","trigger-element":"_xt0be9","disabled":"_1y1tax2","menu":"_1r43000"};
import "../../../assets/DHjmbMrY.css";

export { modules_c052660e as default };
//# sourceMappingURL=Dropdown.module.less.js.map
